export type ClassDashboardRouteState = {
  activeTabIndex?: number;
};

export const enum BusinessTabItems {
  STAFF = 0,
  MONEY = 1,
  REGISTRATION = 2,
  RESOURCES = 3,
}
